import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {AppConfigurationService} from '../shared/app-configuration.service';
import {Parent} from '@model/parent';
import {Observable} from 'rxjs';
import {Page} from '@model/page';
import {SearchData} from '@model/search-data';

@Injectable({
  providedIn: 'root'
})
export class ParentService {
  private readonly _apiUrl: string;

  constructor(private _http: HttpClient, private _appConfig: AppConfigurationService) {
    this._apiUrl = this._appConfig.getConfig().apiUrl + '/schools';
  }

  checkParentWithEmailExists(schoolId: string, email: string) {
    return this._http.head(this._apiUrl + '/' + schoolId + '/parents/byEmail/' + email);
  }

  getParentByEmail(schoolId: string, email: string): Observable<Parent> {
    return this._http.get<Parent>(this._apiUrl + '/' + schoolId + '/parents/byEmail/' + email);
  }

  searchParents(schoolId: string, searchData: SearchData): Observable<Page<Parent>> {
    const parameters: HttpParams = new HttpParams()
      .set('q', searchData.filter)
      .set('page', searchData.pageNumber + '')
      .set('size', searchData.pageSize + '');
    return this._http.get<Page<Parent>>(this._apiUrl + '/' + schoolId + '/parents', {params: parameters});
  }

  getParent(schoolId: string, parentId: number): Observable<Parent> {
    return this._http.get<Parent>(this._apiUrl + '/' + schoolId + '/parents/' + parentId);
  }

  saveParent(schoolId: string, parent: Parent) {
    if (parent.id) {
      return this._http.put<Parent>(this._apiUrl + '/' + schoolId + '/parents/' + parent.id, parent);
    } else {
      return this._http.post<Parent>(this._apiUrl + '/' + schoolId + '/parents', parent);
    }
  }

  deleteParent(schoolId: string, parentId: number): Observable<void> {
    return this._http.delete<void>(`${this._apiUrl}/${schoolId}/parents/${parentId}`);
  }
}
